module.exports = __webpack_public_path__ + "img/body.bab9a4d4.png";